<div class="actionBtn" [ngClass]="{showText: showText}" (click)="execAction()">
    @switch (action?.icon) {
        @case (iconType.phone) {<img class="actionIcon" src="./image/call.png" />}
        @case (iconType.mail) {<img class="actionIcon" src="./image/mail.png" />}
        @case (iconType.link) {<img class="actionIcon" src="./image/link.png" />}
        @case (iconType.eye) {<img class="actionIcon" src="./image/eye.png" />}
    }
    @if (showText) {<div class="title shorten">{{action!.title}}</div>}
</div>
